module.exports = __webpack_public_path__ + "img/1498113042.566b4577.jpg";